import { useTranslation } from 'i18n'
import React, { useState, useEffect } from 'react'
import { SxStyleProp } from 'rebass'

import SText from './SText'
import { objectsEqual } from '../../utils/objects'

interface Props {
    children?: React.ReactNode
    forElementId: string
    sx?: SxStyleProp
}

const SInputError: React.FC<Props> = (props: Props) => {
    const { children, forElementId, sx = {} } = props
    const [forElement, setForElement] = useState<HTMLElement | null>(null)
    const [coords, setCoords] = useState<{
        left: number
        right: number
        width: number
        top: number
    } | null>(null)

    const { t } = useTranslation(window.LANG_NS)

    const ele = document.getElementById(forElementId)
    const onResize = () => {
        setCoords({
            left: ele?.offsetLeft,
            right: ele?.offsetLeft + ele?.offsetWidth,
            width: ele?.offsetWidth,
            top: ele?.offsetTop + ele?.offsetHeight,
        })
    }

    useEffect(() => {
        const c = {
            left: ele?.offsetLeft,
            right: ele?.offsetLeft + ele?.offsetWidth,
            width: ele?.offsetWidth,
            top: ele?.offsetTop + ele?.offsetHeight,
        }
        // @ts-ignore
        if (!objectsEqual(coords, c)) {
            onResize()
        }
    })

    useEffect(() => {
        if (forElementId) {
            setForElement(ele)
            window.addEventListener('resize', onResize)
            return () => {
                window.removeEventListener('resize', onResize)
            }
        }
    }, [forElementId, t, props.children])

    if (!forElement) return null

    return (
        coords && (
            <SText
                fontSize={10}
                sx={{
                    textAlignLast: 'left',
                    whiteSpace: 'pre-line',
                    fontWeight: '500',
                    position: 'absolute',
                    left: coords.left,
                    right: coords.right,
                    width: coords.width,
                    top: coords.top,
                    marginTop: 2,
                    ...sx,
                }}
            >
                {children}
            </SText>
        )
    )
}

export default SInputError
